import { render, staticRenderFns } from "./bao-cao-doanh-thu.vue?vue&type=template&id=a3f18448&scoped=true&"
import script from "./bao-cao-doanh-thu.vue?vue&type=script&lang=js&"
export * from "./bao-cao-doanh-thu.vue?vue&type=script&lang=js&"
import style0 from "./bao-cao-doanh-thu.vue?vue&type=style&index=0&id=a3f18448&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f18448",
  null
  
)

export default component.exports